<template>
  <v-container style="margin-top: 2%; min-height: 100%">
    <v-flex style="min-height: 100%"
      ><v-card class="masterCard" style="min-height: 100%">
        <v-row class="centered" style="margin-left: 5%; margin-right: 5%">
          <v-card-title>
            <v-autocomplete
              :items="rolesNames"
              v-model="Role"
              @change="updateSelections"
            ></v-autocomplete>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="togleAdd"
            v-on:updateSwitchValue="updateSwitchValue"
            >Agregar rol</v-btn
          >
        </v-row>

        <v-progress-circular
          indeterminate
          class="loading"
          color="primary"
          v-if="loading"
        >
          Cargando
        </v-progress-circular>
        <template v-else>
          <v-dialog v-model="AuxDialog" max-width="500px">
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="40" md="40">
                    <v-text-field
                      v-model="newRolName"
                      label="Nombre del rol"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#015CAB" text @click="save">Guardar</v-btn>
                <v-btn color="#E1251B" text @click="close">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <v-card v-for="(permission, index) in currentPermission" :key="index">
          <switchComponent
            v-on:updateSwitchValue="updateSwitchValue"
            :key="permission.value"
            :elementName="permission.permission"
            :value="permission.value"
          />
        </v-card> </v-card
    ></v-flex>
  </v-container>
</template>

<script>
import switchComponent from "@/components/switchComponent.vue";
import {
  getAllroles,
  getAllPermissions,
  addRol,
  togglePermission,
} from "@/utils/apiRequest.js";
export default {
  data() {
    return {
      rolesNames: [],
      rolesList: [],
      AuxDialog: false,
      Role: "",
      newRolName: "",
      selectedRole: {},
      permissionsList: [],
      currentPermission: [],
      loading: true,
    };
  },
  components: {
    switchComponent,
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    updateSelections() {
      this.rolesList.forEach((rol) => {
        if (rol.name == this.Role) {
          this.selectedRole = rol;
          return;
        }
      });
      this.updatePermissionsDisplay();
    },
    updatePermissionsDisplay() {
      let tempPermission = [];
      this.permissionsList.forEach((permission) => {
        let cPermission = {
          permission: permission,
          value: this.calculateValue(this.selectedRole, permission),
        };
        tempPermission.push(cPermission);
      });
      this.currentPermission = tempPermission;
    },
    calculateValue(rol, name) {
      let value = false;
      if (rol.permissions == null) {
        return false;
      }
      rol.permissions.forEach((permission) => {
        if (permission.permission.name.toUpperCase() == name.toUpperCase()) {
          value = true;
        }
      });
      return value;
    },
    togleAdd() {
      this.AuxDialog = !this.AuxDialog;
    },
    close() {
      this.AuxDialog = false;
      this.newRolName = "";
      this.$nextTick(() => {
        this.newRolName = "";
      });
    },
    async save() {
      let updatedRol = await addRol(this.newRolName);
      if (updatedRol.data.status == "success") {
        window.location.reload();
        this.close();
      }
    },
    async updateSwitchValue({ name }) {
      let response = await togglePermission(
        this.selectedRole.name,
        name.elementName
      );
      if (response.data) {
        if (response.data.status == "success") {
          window.location.reload();
        }
      }
    },
  },
  async mounted() {
    let response = await getAllroles();
    if (response.data) {
      if (response.data.status == "success") {
        this.rolesList = response.data.roles;
        this.rolesList.forEach((rol) => {
          this.rolesNames.push(rol.name);
          this.Role = rol.name;
          this.selectedRole = rol;
        });
        this.currentPermission = this.permissionsList;
      }
    }

    response = await getAllPermissions();
    if (response.data) {
      if (response.data.status == "success") {
        let permissions = response.data.permissions;
        permissions.forEach((permission) => {
          this.permissionsList.push(permission.name);
        });
      }
    }
    this.updatePermissionsDisplay();

    this.loading = false;
  },
};
</script>

<style scoped>
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}
</style>